import { render, staticRenderFns } from "./ChatForm.vue?vue&type=template&id=52624f62&"
import script from "./ChatForm.vue?vue&type=script&lang=ts&"
export * from "./ChatForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports